import Text from "@/components/Text";
import { getHistoryRestaurants } from "@/store/historyRestaurantsState";
import { userFavoriteListState } from "@/store/userFavoriteListState";
import { Clock3 } from "lucide-react";
import { useEffect, type FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

const Favorites: FC = () => {
  const { t } = useTranslation();
  const { data: favoriteListRestaurants } = userFavoriteListState();

  useEffect(() => {
    getHistoryRestaurants();
  }, []);

  return (
    <div
      className="bg-[white] overflow-y-auto overflow-x-hidden px-[16px] pt-[36px] pb-[16px] sm:p-[80px]"
      style={{ height: "calc(100dvh - var(--height-header))" }}
    >
      <Text fontSize={24} fontWeight={600}>
        {t("favorites")}
      </Text>

      <div className="grid grid-cols-2 sm:grid-cols-4 mt-[24px] gap-[12px] sm:gap-[32px]">
        <Link to="/favorite/history">
          <div className="bg-[#F1F2F4] rounded-[12px] flex items-center justify-center aspect-square mb-[15px]">
            <Clock3 height={60} width={60} color="#44546F" />
          </div>
          <Text fontSize={16} fontWeight={600}>
            {t("recently_viewed")}
          </Text>
        </Link>

        {favoriteListRestaurants &&
          Object.values(favoriteListRestaurants).map(
            (favoriteListRestaurant) => {
              const { favorite, restaurants } = favoriteListRestaurant;
              const restaurant = restaurants[0];

              return (
                <Link key={favorite.id} to={`/favorite/${favorite.id}`}>
                  <img
                    className="object-cover aspect-square rounded-[12px]"
                    src={restaurant?.imageUrl ?? undefined}
                  />

                  <div className="flex flex-col gap-[4px] mt-[15px]">
                    <Text fontSize={16} fontWeight={600}>
                      {favorite.name}
                    </Text>
                    <Text fontSize={16} fontWeight={600}>
                      {t("favorite_restaurants_count", {
                        count: favorite.restaurantCount,
                      })}
                    </Text>
                  </div>
                </Link>
              );
            },
          )}
      </div>
    </div>
  );
};

export default Favorites;
